<template>
  <el-input-number
    type="number"
    size="mini"
    :controls="false"
    class="r-input dark"
    :disabled="readonly"
    v-model="value"
    :placeholder="placeholder"
    @change="change($event)"
    @mousedown.stop
  />
</template>

<script>
export default {
  props: [
    "readonly",
    "placeholder",
    "emitter",
    "ikey",
    "type",
    "secondary",
    "defaultValue",
    "getData",
    "putData"
  ],
  data() {
    return {
      value: this.initial || 0
    };
  },
  methods: {
    change(value) {
      this.value = value;
      this.update();
    },
    update() {
      if (this.ikey) this.putData(this.ikey, this.value);
      this.emitter.trigger("process");
    }
  },
  mounted() {
    const savedValue = this.getData(this.ikey);

    if (savedValue) {
      this.value = savedValue;
    } else if (this.defaultValue) {
      this.value = this.defaultValue;
    }
    this.update();
  }
};
</script>

<style lang="scss" scoped>
.r-input {
  width: 80px;
}
</style>
